import React, { useState, useEffect, useRef } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import styled from "styled-components";
import RichTextEditor from "components/Global/RichTextEditor";

const Body = styled.div`
  border: 1px solid #DADCE0;
  .DraftEditor-root {
    padding: 0 16px;
  }
  .rdw-editor-toolbar {
    padding: 6px 10px 0;
    border-bottom: 1px solid #DADCE0;
  }
`;

const StyledTable = styled.table`
  margin: 0 auto 2em;
  max-width: 660px;
  width: 100%;
  font-family: Work Sans;
  border-radius: 8px;
  border: 1px solid #DADCE0;
  background-color: ${({ companyPrimaryColor }) => `#${companyPrimaryColor}`};
`;

const StyledInnerTable = styled.table`
  margin-bottom: -17px;
  margin-top: -13px;
  width: 100%;
`;

const StyledLogoImg = styled.img`
  height: 100%;
  width: 100%;
  margin-bottom: -3px;
  margin-left: 6px;
  text-align: left;
  max-height: ${({ maxLogoDimensions }) => maxLogoDimensions.height};
  max-width: ${({ maxLogoDimensions }) => maxLogoDimensions.width};
`;

const PoweredByText = styled.p`
  font-size: 10px;
  font-weight: 400;
  color: #E5E7E8;
  margin-right: -6px;
  font-family: Work Sans;
`;

export const EdcEmailTemplate = ({
  companyLogo,
  companyName,
  companyPrimaryColor,
  template,
  email,
  setEmail
}) => {
  const staticElement = useRef();
  const logoRef = useRef();
  const [maxLogoDimensions, setMaxLogoDimensions] = useState({ height: "40px", width: "40px" });

  useEffect(() => {
    if (logoRef?.current) {
      const { height = 0, width = 0 } = logoRef?.current;
      const isRectangularShape = width >= 1.5 * height;
      isRectangularShape ? setMaxLogoDimensions({ height: "40px", width: "105px" }) : setMaxLogoDimensions({ height: "40px", width: "40px" });
    }
  }, [companyLogo]);

  const onEditorStateChange = change => {
    const newEmail = Object.assign({}, email);
    newEmail.textBody = change;
    setEmail(newEmail);
  };

  const DoNotClick = ({ children }) => {
    useEffect(() => {
      const elemCollection = document.getElementsByClassName("do-not-click");
      const doNotClick = e => e.preventDefault();
      for (const element of elemCollection) {
        element.addEventListener("click", doNotClick);
      }

      return () => {
        for (const element of elemCollection) {
          element.removeEventListener("click", doNotClick);
        }
      };
    }, []);

    return <>{children}</>;
  };

  return (
    <div style={{ width: "1115px" }}>
      <Body>
        <RichTextEditor
          htmlString={email?.textBody}
          handleUpdate={onEditorStateChange}
          maxColumns={6}
          maxLength={1000}
        />
        <DoNotClick>
          <div ref={staticElement}>
            <StyledTable
              companyPrimaryColor={companyPrimaryColor}
              align="center"
              cellSpacing="0"
              cellPadding="0"
            >
              <tr align="center">
                <StyledInnerTable>
                  <tr>
                    {companyLogo &&
                      <td align="left">
                        <p>
                          <StyledLogoImg
                            ref={logoRef}
                            src={companyLogo}
                            alt={`${companyName}-logo`}
                            maxLogoDimensions={maxLogoDimensions}
                          />
                        </p>
                      </td>}
                    <td align="right">
                      <table>
                        <tr>
                          <td align="right">
                            <PoweredByText>Powered by &nbsp;</PoweredByText>
                          </td>
                          <td align="left">
                            <img height="18" width="100" src="https://assets.loanboss.com/loanboss-Logo-White.png" style={{ marginBottom: -2 }} alt="loanboss-Logo-White" />
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </StyledInnerTable>
              </tr>
              <tr style={{ backgroundColor: "#FAFAFA" }}>
                {template()}
              </tr>
            </StyledTable>
          </div>
        </DoNotClick>
      </Body>
    </div>
  );
};
const mapStateToProps = ({ contacts, emailCampaign }) => ({ ...contacts, emailCampaign });

export default compose(connect(mapStateToProps, {}))(EdcEmailTemplate);
